import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Section.module.css';
import { ChevronDownButton, ChevronRightButton, ClearButton } from '_components';
import { RefManager } from '_helpers';

class PatientCareCenterNoteSection extends React.Component {

    constructor(props) {
        super(props)
        this.myRef = React.createRef()
    }

    componentDidMount() {
        RefManager.storeRef(this.props.id, this.myRef);
    }

    getChevron() {
        if (this.props.allowCollapse !== undefined && this.props.allowCollapse === false) {
            return (<span className={styles.no_collapse_pad} />);
        } else if (this.props.visible) {
            return (<ChevronDownButton size='extra-small' className={styles.button} onClick={() => this.props.toggleVisibility({ noteId: this.props.noteId, sectionId: this.props.id, visible: false })} />)
        } else {
            return (<ChevronRightButton size='extra-small' className={styles.button} onClick={() => this.props.toggleVisibility({ noteId: this.props.noteId, sectionId: this.props.id, visible: true })} />)
        }
    }

    renderChildren() {
        if (this.props.visible) {
            return (this.props.children);
        }
        return (<span />);
    }

    renderToolTip() {
        if (this.props.showToolTip && typeof this.props.toolTip === 'function') {
            return (this.props.toolTip());
        }
        return (<span />);
    }

    render() {
        let level = this.props.level ? this.props.level : 0;
        let cls;
        switch (level) {
            case 0:
                if (!this.props.isWp) {
                    cls = this.props.scribing ? styles.wrapper0_scribe : styles.wrapper0;
                }
                else {
                    cls = this.props.scribing ? styles.wrapper0_scribe_wp : styles.wrapper0_wp;
                }
                break;
            case 1:
                if (!this.props.isWp) {
                    cls = this.props.scribing ? styles.wrapper1_scribe : styles.wrapper1;
                } else {
                    cls = this.props.scribing ? styles.wrapper1_scribe_wp : styles.wrapper1_wp;
                }
                break;
            case 2:
                if (!this.props.isWp) {
                    cls = this.props.scribing ? styles.wrapper2_scribe : styles.wrapper2;
                } else {
                    cls = this.props.scribing ? styles.wrapper2_scribe_wp : styles.wrapper2_wp;
                }
                break;
            case 3:
                if (!this.props.isWp) {
                    cls = this.props.scribing ? styles.wrapper3_scribe : styles.wrapper3;
                } else {
                    cls = this.props.scribing ? styles.wrapper3_scribe_wp : styles.wrapper3_wp;
                }
                break;
            case 4:
                if (!this.props.isWp) {
                    cls = this.props.scribing ? styles.wrapper4_scribe : styles.wrapper4;
                } else {
                    cls = this.props.scribing ? styles.wrapper4_scribe_wp : styles.wrapper4_wp;
                }
                break;
            case 5:
                if (!this.props.isWp) {
                    cls = this.props.scribing ? styles.wrapper5_scribe : styles.wrapper5;
                } else {
                    cls = this.props.scribing ? styles.wrapper5_scribe_wp : styles.wrapper5_wp;
                }
                break;
            default:
                if (!this.props.isWp) {
                    cls = this.props.scribing ? styles.wrapper0_scribe : styles.wrapper0;
                } else {
                    cls = this.props.scribing ? styles.wrapper0_scribe_wp : styles.wrapper0_wp;
                }
                break;
        }

        if (this.props.allowCollapse !== undefined && this.props.allowCollapse === false) {
            cls += ' ' + styles.no_bold;
        }

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        let childCls;
        if (this.props.noChildPadding) {
            childCls = styles.child_wrapper_no_collapse;
        } else {
            childCls = this.props.allowCollapse !== undefined && this.props.allowCollapse === false ? styles.child_wrapper_no_collapse : styles.child_wrapper;
        }
        return (
            <span ref={this.myRef}>
                <div ref={this.props.refProp} id={this.props.id}>
                    <div className={cls}>
                        {this.getChevron()}
                        <span className={styles.label}>
                            {this.props.name}
                        </span>
                        {this.props.showClear &&
                            <ClearButton title='Clear Activity Log' onClick={this.props.onClear} size='extra-small' className={styles.clear_button} />
                        }
                        {this.renderToolTip()}
                    </div>
                    <div className={childCls}>
                        {this.renderChildren()}
                    </div>
                </div>
            </span>
        );
    }

}


function mapDispatchToProps(dispatch) {
    return {
        toggleVisibility: bindActionCreators(noteActions.toggleSectionVisibility, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let addUser = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVADDUSER : state.entities.notes.PTNOTE[pk].NTADDUSER;
    let scribing = addUser === state.entities.authentication.user.urno ? false : true;
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isWp = state.entities.admissions[epno].isWP;

    let visible = true;
    if (state.ui.notes[noteId][ownprops.id.toLowerCase() + 'Visible'] !== undefined) {
        visible = state.ui.notes[noteId][ownprops.id.toLowerCase() + 'Visible'];
    } else if (ownprops.visible !== undefined) {
        visible = ownprops.visible;
    }


    return {
        noteId: noteId,
        visible: visible,
        scribing,
        isWp
    };
}

const connectedPatientCareCenterNoteSection = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSection);
export { connectedPatientCareCenterNoteSection as PatientCareCenterNoteSection };

